module.exports = __webpack_public_path__ + "media/images/courses/bg-detail-ec6b1443436ca60d9a7de161d00e7149.jpeg";